<h2 class="title px-5">
  <span (click)="returnToList()" class="material-icons link mr-1">chevron_left</span>
  Detalle Torneo
</h2>

<mat-tab-group (selectedTabChange)="onTabChanged($event)">
  <mat-tab label="Información">
    <div class="tournament_detail_container p-4 m-auto" *ngIf="tournament">
      <div class="d-flex justify-content-between">
        <h2 class="font-weight-bold text-primary mb-0">{{ tournament.name }}</h2>
        <button *ngIf="tournament.state === 0" (click)="publishTournament()" mat-raised-button
          color="primary">Publicar</button>
      </div>
      <p class="text-primary mb-4" *ngIf="fieldsCapacities.length">
        {{ tournament.teams_quantity }} Equipos de
        {{ getTournamentTeamSize(tournament.team_player_quantity) / 2 }} jugadores
      </p>
      <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="1rem">
        <div fxLayout="row" fxLayoutGap="1.5rem">
          <span>Inicia:</span>
          <span>{{ getTournamentDate() }}</span>
        </div>
        <div fxLayout="row" fxLayoutGap="1.5rem">
          <span>Partidos:</span>
          <span>{{ getTournamentDays() }}</span>
        </div>
        <div fxLayout="row" fxLayoutGap="1.5rem">
          <span>Horarios:</span>
          <span>{{ getTournamentTimes() }}</span>
        </div>
        <div fxLayout="row" fxLayoutGap="1.5rem">
          <span>Inscripcion:</span>
          <span>{{ tournament.registration_fee }}</span>
        </div>
        <div fxLayout="row" fxLayoutGap="1.5rem">
          <span>Descripción:</span>
          <span>{{ tournament.description }}</span>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Fixture">
    <tournament-fixture [tournamentId]="tournamentId"></tournament-fixture>
  </mat-tab>
  <mat-tab label="Posiciones">
    <tournament-positions [tournamentId]="tournamentId"></tournament-positions>
  </mat-tab>
  <!-- <mat-tab label="Goleadores"> Goleadores </mat-tab> -->
  <mat-tab label="Equipos">
    <tournament-detail-teams [tournamentId]="tournamentId"></tournament-detail-teams>
  </mat-tab>
</mat-tab-group>